import { TFunction } from 'i18next'
import { DateTime } from 'luxon'
import { ReactNode, memo } from 'react'

import ProfileLogo from '@components/ProfileLogo'
import TruncateLines from '@components/TruncateLines'
import { ProfileType } from '@modules/search/types'
import { Update } from '@modules/updates/types'
import { colors, dateTimeFormats } from '@theme/variables'

import {
  ProfileCell,
  ProfileCellCompanyName,
  ProfileCellInner,
  ProfileCellTitle,
  ReadCell,
  UpdatedAtCell,
} from '../../index.styles'
import CheckmarkInCircleIcon from '../CheckmarkInCircleIcon'
import { UpdateTableRowContainer } from '../index.styles'
import UpdatesCellContent from './UpdatesCellContent'
import { UpdatesTableConfigProps, UpdatesTableRowProps } from './types'

export const getTableColumnsComponents = ({
  update,
  onClickProfile,
  onMarkAsRead,
  t,
}: {
  update: Update
  onClickProfile?: () => void
  t: TFunction<'translations'>
  onMarkAsRead: (profileId: string, profileType: ProfileType) => void
}): Record<UpdatesTableConfigProps['fieldName'], () => ReactNode> => {
  const { companyName, name, title, read, updatedAt, data = [], profileId, profileType, firstName, lastName } = update || {}
  const isAsset = ![ProfileType.delegate, ProfileType.company].includes(profileType)
  return {
    profile: () => (
      <ProfileCell>
        <ProfileLogo
          profileData={update}
          profileType={profileType}
          height={isAsset ? 34 : undefined}
          defaultLogoSize={26}
          width={26}
          circleView
          backgroundColor={colors.lightGrey}
        />
        <ProfileCellInner>
          <ProfileCellTitle href={`/plus/profile/${profileId}/${profileType}`} onClick={onClickProfile}>
            <TruncateLines lines={2}>{title || name || `${firstName} ${lastName}`}</TruncateLines>
            {!!companyName && <ProfileCellCompanyName variant="caption">{companyName}</ProfileCellCompanyName>}
          </ProfileCellTitle>
        </ProfileCellInner>
      </ProfileCell>
    ),
    updates: () => {
      return <UpdatesCellContent profileType={profileType} profileId={profileId} t={t} data={data} />
    },
    updatedAt: () => (
      <UpdatedAtCell>{updatedAt ? DateTime.fromISO(updatedAt).toFormat(dateTimeFormats.eventDateFormat) : ''}</UpdatedAtCell>
    ),
    unread: () => (
      <ReadCell onClick={() => onMarkAsRead(profileId, profileType)}>
        <CheckmarkInCircleIcon isHighlighted={!!read} />
      </ReadCell>
    ),
  }
}

export const UpdateTableRow = memo((props: UpdatesTableRowProps) => {
  const { update, virtualItem, virtualizer } = props

  return (
    <UpdateTableRowContainer
      sx={{
        transform: `translateY(${virtualItem.start - virtualizer.options.scrollMargin}px)`,
      }}
      isDisabled={update?.read}
      key={virtualItem.index}
      data-index={virtualItem.index}
      ref={virtualizer.measureElement}
    >
      {/* @ts-expect-error asd */}
      {update?.columns}
    </UpdateTableRowContainer>
  )
})
